module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-box number"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('button', {
    class: ['btn-icon', 'number-btn-' + this.leftBtnState],
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sub
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jian-xianxingyuankuang"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueSelf),
      expression: "valueSelf"
    }],
    class: ['number-input', 'flex-item-1', _vm.valueSelf == 0 ? 'number-input-hidden' : ''],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.valueSelf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueSelf = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('button', {
    class: ['btn-icon', 'number-btn-' + this.rightBtnState],
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.plus
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-jia-yuankuang"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f473e66e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-number/bo-number.vue
// module id = 58
// module chunks = 7 31